import { Meeting, MeetingResponse, Day, MeetingType } from '@/types.d';

export const mapMeeting = (meetingResponse: MeetingResponse): Meeting => {
  return {
    display: true,
    address: meetingResponse.address,
    coords: {
      lat: meetingResponse.coords[0],
      lng: meetingResponse.coords[1],
    },
    day: meetingResponse.day as Day,
    id: meetingResponse.id,
    name: meetingResponse.name,
    note: meetingResponse.note,
    time: meetingResponse.time,
    type: MeetingType[meetingResponse.type],
    // Legacy docs predate these fields (PAS-25).
    formats: meetingResponse.formats ?? [],
    active: meetingResponse.active ?? true,
  };
};
